import { useState } from "react";
import { useQuery, useMutation } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { Button, Modal, Stack, Group, Select, Box } from "@mantine/core";
import { getCoordinators } from "../../../../services/user";
import { assignTo } from "../../../../services/flag";
import { reactQueryOptions } from "../../../../utils/reactQueryOptions";
import { useCheckPermission } from "../../../../hooks/useCheckPermission";
import { toast } from "react-toastify";
import {
  updateFlagDetails,
  useSelectFlagData,
} from "../../../../redux/features/flagDetails/flagDetailsSlice";
import { useDispatch } from "react-redux";

export default function AssignTo() {
  const dispatch = useDispatch();
  const { id } = useParams();
  const flagData = useSelectFlagData();

  const [popupOpen, setPopupOpen] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const assignToPermission = useCheckPermission("ASSIGN_TO");
  const { isEscalated, locked } = flagData?.flagDetails || {};

  const showAssignTo = !locked && !isEscalated;

  const { data: coordinators } = useQuery({
    queryKey: ["coordinators"],
    queryFn: getCoordinators,
    staleTime: 5 * 60 * 1000,
    ...reactQueryOptions,
  });

  const options = coordinators?.map((e) => ({
    label: `${e.name} - assigned flags - ${e.pendingFlags}`,
    value: String(e.id),
  }));

  const { mutate: assign, isPending } = useMutation({
    mutationFn: () =>
      assignTo({
        flagId: id,
        userId: selectedUser,
      }),
    onSuccess: async ({ data }) => {
      dispatch(updateFlagDetails(data)); // TODO - Сашо - не връща свежи данни
      toast.success("Flag successfully assigned.");
      handleClose();
    },
    onError: (err) => {
      toast.error(err.response?.data?.message);
    },
  });

  function handleClose() {
    setPopupOpen(false);
    setSelectedUser(null);
  }

  if (!assignToPermission || !showAssignTo) return null;

  return (
    <Box>
      <Button
        variant="outline"
        onClick={(e) => {
          setPopupOpen(true);
        }}
      >
        Assign to
      </Button>

      <Modal
        centered
        opened={popupOpen}
        onClose={handleClose}
        withCloseButton={false}
        title="Assign Flag To"
      >
        <Stack gap="sm">
          <Select
            label="Assign to"
            data={options}
            value={selectedUser}
            onChange={setSelectedUser}
          />
          <Group justify="space-between">
            <Button variant="outline" color="red" onClick={handleClose}>
              Cancel
            </Button>
            <Button
              variant="outline"
              color="green"
              disabled={!selectedUser}
              loading={isPending}
              onClick={() => assign()}
            >
              Confirm
            </Button>
          </Group>
        </Stack>
      </Modal>
    </Box>
  );
}
